import zappy from "@zappy-ride/library.react.components";
import { PrintTabs } from "./PrintTabs";
export * from "./PrintTabs";

zappy.FactoryInstance.registerComponent(PrintTabs);
